import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";

import { DocumentoVendaBrowseComponent } from "./views/documentoVenda/browse/documentoVenda-browse.component";
import { ContratoBrowseComponent } from "./views/contrato/browse/contrato-browse.component";
import { ContratoEditComponent } from "./views/contrato/edit/contrato-edit.component";
import { PedidoIntervencaoBrowseComponent } from "./views/pedidoIntervencao/browse/pedidoIntervencao-browse.component";
import { PedidoIntervercaoEditComponent } from "./views/pedidoIntervencao/edit/pedidoIntervencao-edit.component";
import { LogisticaBrowseComponent } from "./views/logistica/browse/logistica-browse.component";
import { CanActivateNavigation } from "./shared/services/security.service";
import { ChangePasswordComponent } from "./shared/components/profile/changepassword.component";
import { HomeComponent } from "./views/home/home.component";
import { P404Component } from "./shared/components/pages/404.component";
import { LoginComponent } from "./shared/components/login/login.component";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "home",
    component: HomeComponent,
    data: { title: "Home", navigationName: "home", lockId: 6000 },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "contratos",
    component: ContratoBrowseComponent,
    data: { title: "Contratos", navigationName: "contratos", lockId: 6001 },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "contratos/:contratoId",
    component: ContratoEditComponent,
    data: { title: "Contratos", navigationName: "contratos", lockId: 6001 },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "documentos",
    component: DocumentoVendaBrowseComponent,
    data: { title: "Documentos", navigationName: "documentos", lockId: 6002 },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "pedidoIntervencao",
    component: PedidoIntervencaoBrowseComponent,
    data: {
      title: "Pedidos de Intervenção",
      navigationName: "pedidoIntervencao",
      lockId: 6003,
    },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "pedidoIntervencao/new",
    component: PedidoIntervercaoEditComponent,
    data: {
      title: "Pedido de Intervenção",
      navigationName: "pedidoIntervencao",
      lockId: 6003,
    },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "pedidoIntervencao/:pedidoIntervencaoId",
    component: PedidoIntervercaoEditComponent,
    data: {
      title: "Pedido de Intervenção",
      navigationName: "pedidoIntervencao",
      lockId: 6003,
    },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "logistica",
    component: LogisticaBrowseComponent,
    data: { title: "Logística", navigationName: "logistica", lockId: 6005 },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "login",
    component: LoginComponent,
    data: { title: "Login" },
  },
  {
    path: "changepassword",
    component: ChangePasswordComponent,
    data: { title: "Change Password", navigationName: "changepassword" },
    canActivate: [CanActivateNavigation],
  },
  {
    path: "**",
    component: P404Component,
    data: { original: true },
  },
];

const isIframe = window !== window.parent && !window.opener;
const config: ExtraOptions = {
  initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled",
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
